import React, { useEffect, useCallback, useState} from 'react';
import TrackTimeLine from './TrackTimeLine.js';
import {connect} from 'react-redux';

const SubSequenceTracks = ({
    yScrollContainer,
    wrapperRef,
    subSequence,
    style,
    show,
    width}) => { 
    if (!show) {
        return '';
    }
    return (
        <div className="sub-sequence-tracks">
        {subSequence.tracks.map(
            track =>
                <TrackTimeLine
                  yScrollContainer={yScrollContainer}
                  subSequence={subSequence}
                  width={width}
                  wrapperRef={wrapperRef}
                  style={style}
                  track={track}/>)}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      show: state.arrangement.showTracks[props.subSequence.id],
      numTracks: props.subSequence.tracks && props.subSequence.tracks.length
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubSequenceTracks);
